/* Optional presentation enhancements; the page remains usable without them. */
(() => {
  'use strict';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const inside=document.getElementById('viulet-v36').querySelector('.surface-reveal');
  if(inside && !reduced.matches && 'IntersectionObserver' in window){
    inside.classList.add('surface-ready');
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){
        inside.classList.add('surface-entered');observer.disconnect();
      }
    },{threshold:0.02,rootMargin:'0px 0px -30px 0px'});
    observer.observe(inside);
    reduced.addEventListener('change',()=>{if(reduced.matches){inside.classList.add('surface-entered');observer.disconnect();}});
  }
})();
